export default __webpack_public_path__ + "static/media/Backwater_LE.f2ddf01f.jpg";